module.exports = __webpack_public_path__ + "img/solve_pic03.ef1c61cf.jpg";